import { render, staticRenderFns } from "./MappingCabangDetail.vue?vue&type=template&id=10612f8d&scoped=true"
import script from "./MappingCabangDetail.vue?vue&type=script&lang=js"
export * from "./MappingCabangDetail.vue?vue&type=script&lang=js"
import style0 from "./MappingCabangDetail.vue?vue&type=style&index=0&id=10612f8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10612f8d",
  null
  
)

export default component.exports